<template>
  
<div class="page-login">
  <div class="ui centered grid container">
    <div class="eight wide column">
      <div class="ui icon warning message">
          <i class="lock icon"></i>
          <div>
            <h5 class="ui header">Integration - Login</h5>
            
          </div>
        </div>
      <div class="ui fluid card">
        <div class="content">
        <form class="ui form" @submit.prevent="onSubmit">

         <div class="field">
       
             <div class="ui left icon input">
            <i class="user icon"></i>
            <input id="login-username" type="text" class="form-control" v-model="input.username"  placeholder="User Name" required autofocus >  
          </div>
          </div>
          <div class="field">
        
           <div class="ui left icon input">
            <i class="lock icon"></i>
             <input id="login-password" type="password" class="form-control" v-model="input.password" placeholder="Password" required>
          </div>
          </div>
     
          <button v-if="login" class="ui primary labeled icon button" >
            <i class="unlock alternate icon"></i>
            Login
          </button>
          <button v-if="loginprogress" class="ui primary loading button">
             <i class="unlock alternate icon"></i>
            Loading</button>
        </form>
        </div>
      </div>
    </div>
  </div>
</div>

</template>
<script>
    import axios from "axios";
    import Vue from 'vue'

     export default {
        name: 'login',
        data () {
            return {
                input: {
                    username: ""
                    ,password: ""
                } ,
                menu :[] ,
                login : 1 ,
                loginprogress : 0  ,
                 int_platform_input: {
                    username: ""
                    ,key: Vue.prototype.$intPlatform_key
                }          
            }
        },
        created(){
            this.clearLocalStorage()
        },
       
       methods: {
           clearLocalStorage(){
                localStorage.removeItem('vendorSelected');
                localStorage.removeItem('communitySelected');
                localStorage.removeItem('userprofile');
                localStorage.removeItem('id_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('expiry_date');
                localStorage.removeItem('isDocList');
                localStorage.removeItem('isCorssList');
                localStorage.removeItem('isLocList');
                localStorage.removeItem('isHistList');
                localStorage.removeItem('isDelDocList');

                localStorage.removeItem('menuCliked');
                localStorage.removeItem('menu');
                localStorage.removeItem('int_platform_token');
           },
            onSubmit() {
               this.loginprogress = 1;
               this.login = 0;
                 this.getPlatformToken();
               
               // this.sleep(100000);
          
                
            },
            bindMenu: async function (){
            let result = await this.getMenu();
            this.menu = result.data;
            if(this.menu.length == 0)
            this.$router.push({name: 'Noaccess'})
            for (var i = 0; i < this.menu.length; i++) {
            if(this.menu[i].redirectingLink == null){
             this.$router.push({name: 'Noaccess'})
            }else{
              localStorage.setItem('menuCliked', this.menu[i].redirectingLink);
              this.$router.push({name: this.menu[i].redirectingLink})
              break;
            }
            }
            return result;
          },
            getMenu: async function (){
            const rsp =  await axios({ method: "GET", "url": Vue.prototype.$hostname + "getrolemappinglist/null" , 
              "headers": 
                { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }),result = await rsp;
            localStorage.setItem("menu", JSON.stringify(result));    
            return  result ; 
              
            },
             getToken: async function (){
              console.log('before symp tok');
               await  axios({ method: "POST", "url": Vue.prototype.$appName + "token/GetBearerToken", 
               "data": this.input, 
                "headers": { "Access-Control-Allow-Origin" : "*",
                    "content-type": "application/json" } }).then
                (
                    result => {
                    this.response = result.data;
                   /*localStorage.setItem('userprofile', this.input);*/
                    localStorage.setItem('id_token', result.data.access_token);
                    localStorage.setItem('refresh_token', result.data.refresh_token);
                    console.log('after symp tok');
                    var now = new Date();
                    now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
                    now = new Date(now); // Date object
                    localStorage.setItem('expiry_date', now);
                    console.log('before menu ');
                    this.bindMenu();
                     console.log('after menu ');
                    
              }, 
                error => {
                    this.loginprogress = 0;
                    this.login = 1;
                     if (error.response.status === 406 ) {
                        sweetAlert('Login failed!', 'You might have misspelled your username or password!', 'error')
                    }else{ 
                    sweetAlert('Something\'s Wrong!', error, 'error')
                    }
                 console.error(error);
                });
              
            },
            getPlatformToken: async function (){
               console.log('before plat tok');
            this.int_platform_input.username= this.input.username;
            console.log(this.int_platform_input.username);
            console.log(this.int_platform_input.key);
             await axios({ method: "POST", "url": Vue.prototype.$intPlatform_url + "generatetokenbyid", 
                    "data": this.int_platform_input, 
                      "headers": { 
                        "Access-Control-Allow-Origin" : "*",
                          "content-type": "application/json" } }).then
                      (
                          result => {
                           
                             localStorage.setItem('int_platform_token', result.data.accessToken);
                              localStorage.setItem('int_platform_token_expiry_date', result.data.expiresIn);
                               localStorage.setItem('int_platform_refresh_token', result.data.refreshToken);
                            console.log('after plat tok');
                           
              

                            var EST_Date =  new Date(result.data.expiresIn);
                         
                            console.log(EST_Date);
                            console.log('after plat Double Ok');
                            this.getToken();
                          }
                      )

  
            
              
            },
               sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  })
}

        }
    }
</script>

 <style type="text/css">
body {
  background-color:#f9fafb;
}

.page-login {
  margin-top: 200px;
}
     </style>

 


// WEBPACK FOOTER //
// src/components/auth/Login.vue